import React from 'react'

class ButtonReceitas extends React.Component {
    render(){
        return(
        <div>
            <i style={{ marginLeft:5, marginRight:5 }} title="Ver receita" data-toggle="modal" data-target={`#ModalReceita${this.props.index}`} className="fas fa-plus"></i>
            <div className="modal fade" id={`ModalReceita${this.props.index}`} tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">{this.props.tituloModal}</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    {this.props.descricaoModal}
                </div>
                {/* <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button type="button" className="btn btn-primary">Save changes</button>
                </div> */}
                </div>
            </div>
            </div>
        </div>
        );
    }
}

export default ButtonReceitas;